module.exports = __webpack_public_path__ + "static/01-d8edb9540037687c328f07904ee76f9e.jpg";